import { API } from '../api.js';
import { useState } from 'react';
import Avatar from './Avatar';
import styles from '../tabs/CommunityTab.module.css';

export default function CommentItem({ 
  comment, 
  level = 0, 
  children, 
  onReply, 
  onLike, 
  onDislike, 
  onEdit, 
  onDelete, 
  onTogglePublish, 
  currentUserId,
  optionsOpen,
  setOptionsOpen
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [editContent, setEditContent] = useState(comment.content);

  const isAuthor = currentUserId === comment.authorId;
  const isDeleted = comment.isDeleted || comment.content === '[Deleted]';

  const handleEditSubmit = () => {
    if (editContent.trim() && editContent !== comment.content) {
      onEdit(comment.id, editContent);
    }
    setIsEditing(false);
  };

  if (isDeleted && (!children || children.length === 0)) {
    return null; // Don't render leaf deleted comments
  }

  return (
    <div className={styles.commentThread} style={{ marginLeft: level > 0 ? 32 : 0 }}>
      <div className={styles.commentItem}>
        <Avatar user={{ avatar: comment.authorAvatar, name: comment.authorName }} size={32} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className={styles.commentContent}>
            <div className={styles.commentAuthorWrap}>
              <div className={styles.commentAuthor}>{comment.authorName}</div>
              {isAuthor && !isDeleted && (
                <div className={styles.commentOptionsWrap} style={{ position: 'relative' }}>
                  <button 
                    className={styles.commentOptionsBtn} 
                    onClick={() => setOptionsOpen(optionsOpen === comment.id ? null : comment.id)}
                  >
                    ⋮
                  </button>
                  {optionsOpen === comment.id && (
                    <div className={styles.postOptionsMenu} style={{ right: 0, top: 20 }}>
                      <button onClick={() => { setIsEditing(true); setOptionsOpen(null); }}>✏️ Edit</button>
                      <button onClick={() => { onTogglePublish(comment); setOptionsOpen(null); }}>
                        {comment.isPublished ? '🚫 Unpublish' : '👁️ Publish'}
                      </button>
                      <button onClick={() => { onDelete(comment.id); setOptionsOpen(null); }} style={{ color: '#ff4d4f' }}>
                        🗑️ Delete
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
            
            {!comment.isPublished && !isAuthor ? (
              <div style={{ fontStyle: 'italic', color: 'var(--text3)' }}>[This comment is unpublished]</div>
            ) : isDeleted ? (
              <div style={{ fontStyle: 'italic', color: 'var(--text3)' }}>[Deleted]</div>
            ) : isEditing ? (
              <div style={{ marginTop: 8 }}>
                <textarea 
                  className={styles.commentInput} 
                  style={{ width: '100%', minHeight: 60, padding: '8px 12px', resize: 'vertical' }}
                  value={editContent}
                  onChange={e => setEditContent(e.target.value)}
                />
                <div style={{ display: 'flex', gap: 8, marginTop: 8, justifyContent: 'flex-end' }}>
                  <button className="btn btn-ghost btn-sm" onClick={() => { setIsEditing(false); setEditContent(comment.content); }}>Cancel</button>
                  <button className="btn btn-primary btn-sm" onClick={handleEditSubmit}>Save</button>
                </div>
              </div>
            ) : (
              <>
                <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', opacity: comment.isPublished ? 1 : 0.6 }}>
                  {comment.content}
                </div>
                {comment.imageUrl && (
                  <img src={`${API}${comment.imageUrl}`} alt="Comment attachment" style={{ maxWidth: '100%', maxHeight: 200, borderRadius: 8, marginTop: 8, objectFit: 'contain', background: '#000' }} />
                )}
                
                {(comment.likesCount > 0 || comment.dislikesCount > 0) && (
                  <div className={styles.commentReactionBadge}>
                    {comment.likesCount > 0 && <span>👍 {comment.likesCount}</span>}
                    {comment.dislikesCount > 0 && <span>👎 {comment.dislikesCount}</span>}
                  </div>
                )}
              </>
            )}
          </div>
          
          {!isDeleted && comment.isPublished && (
            <div className={styles.commentActions}>
              <button className={styles.commentActionBtn} onClick={() => onLike(comment.id, comment.postId)}>
                Like
              </button>
              <button className={styles.commentActionBtn} onClick={() => onDislike(comment.id, comment.postId)}>
                Dislike
              </button>
              {level < 2 && (
                <button className={styles.commentActionBtn} onClick={() => onReply(comment)}>
                  Reply
                </button>
              )}
              <span className={styles.commentTime} style={{ marginLeft: 4 }}>
                {new Date(comment.createdAt).toLocaleString()}
              </span>
            </div>
          )}
        </div>
      </div>
      
      {children && children.length > 0 && (
        <div className={styles.commentReplies}>
          {children}
        </div>
      )}
    </div>
  );
}
